import { Box, Inline, Text } from 'braid-design-system';
import React from 'react';

import { formatPriceBand } from 'src/utils/investmentBands';

interface ValueProps {
  min: number;
  max: number;
}

export const MAX_PRICE = 2000000;

export const Value = ({ min, max }: ValueProps) => (
  <Inline space="xsmall">
    <Text weight="strong">Value:</Text>
    <Box data-testid="profile-saved-searches-value-display-text">
      <Text>
        between {formatPriceBand(min)} and{' '}
        {max <= MAX_PRICE
          ? formatPriceBand(max)
          : `Over ${formatPriceBand(MAX_PRICE)}`}
      </Text>
    </Box>
  </Inline>
);
